export const PAGE_INFO = {
    // 경영실적
    M01:[{
        title: '실적요약',
        pageNo: '10'
    },{
        title: '전년대비',
        pageNo: '11'
    },{
        title: '전월대비',
        pageNo: '12'
    }],

    // 자금관리
    M02:[{
        title: '자금요약',
        pageNo: '20'
    },{
        title: '자금일보',
        pageNo: '21'
    },{
        title: '입출금내역',
        pageNo: '22'
    }],

    // 세금관리
    M03:[{
        title: '부가세/법인세',
        pageNo: '30'
    },{
        title: '원천세',
        pageNo: '31'
    }],

    // 채권채무
    M03:[{
        title: '외상매출금',
        pageNo: '30'
    },{
        title: '외상매입금',
        pageNo: '31'
    },{
        title: '미수금',
        pageNo: '30'
    },{
        title: '미지급금',
        pageNo: '31'
    }],

    // 전표입력
    // O2O알리미
    // 설정

    // 가계부 관리
    bookManage: [{
        title: '목록',
        pageNo: '10010',
        id: 'list',
        path: ''
    },{
        title: '통계',
        pageNo: '10010',
        id: 'stat',
        path: ''
    }],
             
    // 예산관리
    budgetManage: [{
         title: '월간 예산',
         pageNo: '10010',
         id: 'monthly',
         path: ''
    },{
         title: '연간 예산 성적표',
         pageNo: '10010',
         id: 'year',
         path: ''
    }],
             
    // 재무보고서
    financialReport: [{
        title: '월간\n리포트',
        pageNo: '10060',
        id: 'cash',
        path: '/financialReport/cash',
        subTab: [{
            title: '수입지출흐름표',
            id: 'flow',
            path: '/financialReport'
        },{
            title: '가계성적표',
            id: 'grade',
            path: ''
        }]
    },{
        title: '자산·부채\n리포트',
        pageNo: '10061',
        id: 'jasan',
        path: '/financialReport/jasan'
    },{
        title: '재무비율\n점검표',
        pageNo: '10062',
        id: 'check',
        path: '/financialReport/check'
    }
    ],
    // 설정
    setting: [{
        title: '내 정보 수정',
        pageNo: '10010',
        id: 'setting',
        path: '/myInfo'
    }
    /*,
    {
        title: '부가서비스 / 결제 내역',
        pageNo: '10010',
        id: 'payment',
        path: ''
    }*/
    ],

    // 자산관리
    asset: [{
        title: '자산 목록',
        pageNo: '10010',
        id: 'list',
        path: ''
    },{
        title: '숨김 자산',
        pageNo: '10010',
        id: 'hidden',
        path: ''
    },{
        title: '삭제 자산',
        pageNo: '10010',
        id: 'delete',
        path: ''
    }],

    // 분류설정
    category: [{
        title: '기본',
        pageNo: '10010',
        id: 'basic',
        path: ''
    },{
        title: '재무상담사',
        pageNo: '10010',
        id: 'financial',
        path: ''
    },{
        title: '직접입력',
        pageNo: '10010',
        id: 'manual',
        path: ''
    }],

    // 장부이동
    changeBook: [{
        title: '장부이동',
        pageNo: '10010',
        id: 'move',
        path: ''
    },{
        title: '연결요청',
        pageNo: '10010',
        id: 'request',
        path: '',
        subTab: [{
            title: '보낸 요청',
            id: 'send',
            path: ''
        },{
            title: '받은 요청',
            id: 'receive',
            path: ''
        }]
    }],

    // 결제관리
    payment: [{
        title: '부가 서비스',
        pageNo: '10010',
        id: 'basic',
        path: ''
    },{
        title: '결제 내역',
        pageNo: '10010',
        id: 'financial',
        path: ''
    }],

    // 고객센터
    center: [{
        title: '1:1 문의',
        pageNo: '10010',
        id: 'basic',
        path: ''
    },{
        title: 'FAQ',
        pageNo: '10010',
        id: 'financial',
        path: ''
    },{
        title: '공지사항',
        pageNo: '10010',
        id: 'manual',
        path: ''
    }]
}


// WEBPACK FOOTER //
// ./src/constants/pageInfo.js